export const WrappedButtonType = Object.freeze({
	Primary: 'primary',
	Secondary: 'secondary',
	Facebook: 'facebook',
	Twitter: 'twitter',
	TertiaryGrey: 'tertiary-grey',
	TertiaryWhite: 'tertiary-white',
	TertiaryGhost: 'tertiary-ghost',
	Upgrade: 'upgrade',

	// same as transparent but no button text
	Icon: 'icon',
});
